import { Type } from '@angular/core';

export class Payment {
    constructor(
        public component: Type<any>,
        public bankCodes?: string[],
        public bankType?: string,
        public isDefault: boolean = false) { }
}


// WEBPACK FOOTER //
// ./src/pages/recharge/payment.ts